import { Box } from '@mui/material';

interface ArtworkStatusRibbonProps {
  isSold: boolean;
  price: number | string;
  variant?: 'card' | 'detail';
}

export default function ArtworkStatusRibbon({
  isSold,
  price,
  variant = 'card',
}: ArtworkStatusRibbonProps) {
  const numericPrice = Number(price);

  const label = isSold
    ? 'SOLD'
    : numericPrice === 0
      ? 'NOT FOR SALE'
      : null;

  if (!label) {
    return null;
  }

  const isDetail = variant === 'detail';

  return (
    <Box
      sx={{
        position: 'absolute',
        top: isDetail ? 20 : 24,
        right: isDetail ? -30 : -30,
        width:  190,
        py: isDetail ? 1 : 0.75,
        textAlign: isSold ? 'center' : isDetail ? 'right' : 'center',
        backgroundColor: '#b71c1c',
        color: '#fff',
        fontWeight: 'bold',
        fontSize: isDetail ? '1.1rem' : '1rem',
        transform: 'rotate(45deg)',
        transformOrigin: 'center',
        zIndex: 3,
        letterSpacing: '0.08em',
        boxShadow: 2,
        whiteSpace: 'nowrap',
        lineHeight: 1.2,
      }}
    >
      {label}
    </Box>
  );
}